import { httpsCallable } from "firebase/functions";
import { functions } from "shared/api/firebase";
import { AdminRole } from "../types";

export type CreateAdminParams = {
  email: string;
  roles: AdminRole[];
};

export type CreateAdminResponse = {
  id: string;
  email: string;
  roles: AdminRole[];
};

const createAdmin = async (
  params: CreateAdminParams,
): Promise<CreateAdminResponse> => {
  const fn = httpsCallable<CreateAdminParams, CreateAdminResponse>(
    functions,
    "createAdmin",
  );
  const response = await fn(params);
  return response.data;
};

export default createAdmin;
